import React, { FC, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { CreateSfBankAccountRequestDto } from '@sparling/financial-common'
import { endOfDay, startOfDay } from 'date-fns'
import { DataPicker } from '../../../../components/DatePicker'
import { Search } from '../../../../components/Search'
import { FilterSelect } from '../../../../components/FilterSelect'
import { getSfBankAccountsRequest, resetSfBankAccountsFilters } from '../../../../store/actions'
import { fiatsEnumSelector } from '../../../../store/selectors'

interface IFiltersFields {
  fromDate?: string
  toDate?: string
  currency?: string
  search?: string
}

export const BankAccountsFilters: FC = () => {
  const dispatch = useDispatch()
  const fiatsEnum = useSelector(fiatsEnumSelector)
  const formMethods = useForm<IFiltersFields>({ mode: 'onChange' })
  const { watch, getValues } = formMethods

  useEffect(() => {
    dispatch(resetSfBankAccountsFilters())
  }, [dispatch])

  useEffect(() => {
    const subscription = watch(() => {
      dispatch(getSfBankAccountsRequest(getValues() as CreateSfBankAccountRequestDto))
    })
    return () => subscription.unsubscribe()
  }, [dispatch, getValues, watch])

  return (
    <FormProvider {...formMethods}>
      <DataPicker
        placeholder={'Start Date'}
        margin={'0 8px'}
        dataPickerName={'fromDate'}
        required={false}
        maxDate={getValues().toDate}
        formatValue={startOfDay}
      />
      <DataPicker
        placeholder={'End Date'}
        margin={'0 8px'}
        dataPickerName={'toDate'}
        required={false}
        minDate={getValues().fromDate}
        formatValue={endOfDay}
      />
      <FilterSelect inputName="currency" placeholder="Currency" enums={fiatsEnum} mr={8} ml={8} width={138} />
      <Search inputName={'search'} />
    </FormProvider>
  )
}
